<template>
  
  <div class="columns is-centered mt-5">
    <div class="column is-half-tablet">

      <div class="box">
        <form @submit.prevent>
          <h1 class="title">Register a new account</h1>
          
          <b-field label="Title" label-for="title" message="Lie about your status and the Inquisition shall find you">
            <b-input v-model.trim="title" id="title" placeholder="Mr, Dr, Sergeant, Lord"></b-input>
          </b-field>

          <b-field label="Name" label-for="name" message="We never share you full name publically, only crusade organisers you give permission can see this">
            <b-input v-model.trim="name" id="name" placeholder="Your Real Name" autocomplete="name"></b-input>
          </b-field>

          <b-field label="Email" label-for="email" 
            :type="{'is-danger': errors.find((currentValue) => { return currentValue.email})}"
            :message="errors.find((currentValue) => { return currentValue.email }) && errors.find((currentValue) => { return currentValue.email }).email  || 'For login and crusade management purposes only'">
            <b-input v-model.trim="email" id="email" placeholder="Email" autocomplete="email"></b-input>
          </b-field>

          <b-field label="Password" label-for="password" 
            :type="{'is-danger': errors.find((currentValue) => { return currentValue.passsword})}"
            :message="errors.password || 'At least 6 characters'">
            <b-input type="password" v-model.trim="password" id="password"  autocomplete="new-password"></b-input>
          </b-field>
      
          <button @click="signup()" class="button is-primary">Sign Up</button>
          <div class="extras mt-3 content is-small">
            Already got an account? <router-link :to="{name: 'account.login'}">Switch to Log In</router-link>
          </div>

        </form>
      </div>

    </div>
  </div>
    
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      name: "",
      title: "",
      email: "",
      password: ""
    };
  },
  computed: {
    ...mapState(['errors'])
  },
  methods: {
    signup() {
      this.$store.dispatch("signup", {
        //TODO mapActions
        email: this.email,
        password: this.password,
        name: this.name,
        title: this.title
      });
    }
  }
};
</script>
<style lang="scss" scoped>
  .box {
    background: #fff;
  }
</style>